import advertiser from '../pictures/extensions/advertiser.webp';
import advertiser2 from '../pictures/extensions/advertiser.webp';

const extensionsData = [
  {
    webp: advertiser,
    png: advertiser2,
    name: 'PropellerAds Advertiser',
    info: 'Keep an eye on your spendings. This extension shows your balance and daily spendings in real time.',
    installLink:
      'https://chrome.google.com/webstore/detail/propellerads-advertiser/ccfeocaphcnobhoieomkgflenhkjgpcd?hl',
    infoLink: '/extensions/advertiser',
    comments: [],
    page: {
      description: '',
      instruction: {},
    },
    meta: {
      content:
        'PropellerAds Advertiser — free extension for Chrome browser. Keep an eye on your spendings. This extension shows your balance and daily spendings in real time.',
      title: 'PropellerAds Advertiser — free extension for Chrome browser',
    },
    isNewLabel: false
  },
];

export default extensionsData;
